// The `languages` table stores 2-letter handles (e.g. "de", "en" — see
// getUserObjectByEmail.js), while the form-builder schema uses BCP-47-ish
// codes ("de-DE"). Map known handles; unknown values pass through unchanged.
const HANDLE_TO_LOCALE = {
  de: 'de-DE',
  en: 'en-US',
  fr: 'fr-FR',
  it: 'it-IT',
  es: 'es-ES',
  nl: 'nl-NL',
  pl: 'pl-PL',
};

export default function languageHandleToLocale(handle) {
  if (!handle) return '';
  const trimmed = String(handle).trim();
  if (/^[a-z]{2}-[A-Z]{2}$/.test(trimmed)) return trimmed;
  return HANDLE_TO_LOCALE[trimmed.toLowerCase()] || trimmed;
}
